import Repository from './Repository';

const resource = '/perfis';

export default {
  get() {
    return Repository.get(`${resource}`);
  },

  buscar(filtros) {
    return Repository.post(`${resource}/filtros`, filtros);
  },

  update(perfil) {
    if (!perfil.instrutorCapacitacao) {
      perfil.areasCapacitacaoInstrutor = [];
    }
    if (!perfil.instrutorCultura) {
      perfil.areasCulturaInstrutor = [];
    }
    if (!perfil.instrutorEsporte) {
      perfil.areasEsporteInstrutor = [];
    }
    if (!perfil.deficiente) {
      perfil.deficiencias = [];
      perfil.observacoesDeficiencias = null;
    }
    if (!perfil.temNomeSocial) {
      perfil.nomeSocial = null;
    } else {
      perfil.nomeSocial = (perfil.nomeSocial != null ? perfil.nomeSocial.toUpperCase() : null);
    }

    return Repository.put(`${resource}`, perfil);
  },
};
